import Controller from "../../../../core/js/Controller";

export default class Auth extends Controller {
    constructor() {
        super();

        this.body = document.querySelector('body');
        this.reg
    }

    afterInit() {

    }

    close(e) {
        e.preventDefault();

        this.body.removeClass('modal-open');
        this.app_container.removeClass('open');
        setTimeout(function () {
            this.app_container.addClass('hidden');
        }.bind(this), 300);
    }

    openRegistration(e) {
        e.preventDefault();

        this.auth.hide();
        this.reg.show();
    }

    openAuthorization(e) {
        e.preventDefault();

        this.auth.show();
        this.reg.hide();
    }
}